import { AnyAction } from 'redux';
import {
  ORDER_SUMMARY_RECEIVED
} from '../constants';


export interface OrderSummaryState {
    minShippingCost?: number;
    shippingMethodCost?: number;
    grandTotalWithShippingCost?: number;
    formattedGrandTotalWithShippingCost?: string;
    formattedShippingMethodCost?: string;
    formattedMinShippingCost?: string;
}

const DEFAULT_STATE: OrderSummaryState = {
    shippingMethodCost: 0,
    grandTotalWithShippingCost: 0
}

export const orderSummary = (state: OrderSummaryState = DEFAULT_STATE, action: AnyAction): OrderSummaryState => {
  switch (action.type) {
    case ORDER_SUMMARY_RECEIVED:
       return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};